import { ReactNode, useMemo, useState } from 'react';
import MyOrganizationDataContext from '@raas/shared/src/features/organization/contexts/MyOrganizationContext';
import type {
  OrganizationContract,
  OrganizationGroupContract,
} from '@raas/shared/src/features/organization/contracts/organization.type';

type MyOrganizationProviderProps = {
  children: ReactNode;
};

export function MyOrganizationProvider({ children }: MyOrganizationProviderProps) {
  const [myOrganization, setMyOrganization] = useState<OrganizationContract | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [myOrganizationGroups, setMyOrganizationGroups] = useState<OrganizationGroupContract[]>([]);
  const [isLoadingGroups, setIsLoadingGroups] = useState<boolean>(false);

  const dataValue = useMemo(
    () => ({
      myOrganization,
      isLoading,
      setMyOrganization,
      setIsLoading,
      myOrganizationGroups,
      isLoadingGroups,
      setMyOrganizationGroups,
      setIsLoadingGroups,
    }),
    [myOrganization, isLoading, myOrganizationGroups, isLoadingGroups]
  );
  return (
    <MyOrganizationDataContext.Provider value={dataValue}>
      {children}
    </MyOrganizationDataContext.Provider>
  );
}
